import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { ArticleTypeSearchDto } from './dto/article-type-search.dto';
import { ArticleTypeDto } from './dto/article-type.dto';

@Injectable({
  providedIn: 'root',
})
export class ArticleTypeService {
  constructor(private _apiService: ApiService) {}

  search(dto: ArticleTypeSearchDto): Promise<PagedResultGeneric<ArticleTypeDto>> {
    return this._apiService.getPaged('ArticleTypes/Search', dto);
  }
}
